/**
 * Created by anabel on 18/10/2017.
 */
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class LocalStorageService {

  constructor(private storage: Storage) {
  }
  open=false;
  pageselected:any;
  // This returns a promise but we can get away without handling it in this case.

  getUser() {
    return this.storage.get('user');
  }

  setUser(profile: any) {
    return this.storage.set('user', profile);
  }

  removeUser() {
    return this.storage.remove('user');
  }

  getToken() {
    return this.storage.get('accessToken');
  }

  setToken(token: string) {
    return this.storage.set('accessToken', token);
  }

  getTokenFirebase() {
    return this.storage.get('tokenFirebase');
  }

  setTokenFirebase(token: string) {
    return this.storage.set('tokenFirebase', token);
  }

  setRanking(ranking: any) {
    return this.storage.set('ranking', ranking);
  }

  getRanking() {
    return this.storage.get('ranking');
  }

  removeAccessToken() {
    return this.storage.remove('accessToken');
  }

  clearKeys() {
    return this.storage.clear();
  }

  getKeys() {
    return this.storage.keys();
  }

  getLastSessionDate() {
    return this.storage.get('lastSessionDate');
  }

  setLastSessionDate(sessionDate: string) {
    return this.storage.set('lastSessionDate', sessionDate);
  }

  getLastCheckVersionDate() {
    return this.storage.get('lastCheckVersionDate');
  }

  setLastCheckVersionDate(checkDate: string) {
    return this.storage.set('lastCheckVersionDate', checkDate);
  }

  getCheckVersionApp() {
    return this.storage.get('checkVersion');
  }

  setCheckVersionApp(checkVersion: any) {
    return this.storage.set('checkVersion', checkVersion);
  }

  removeLastCheckVersionDate() {
    return this.storage.remove('lastCheckVersionDate');
  }

  getAppConf() {
    return this.storage.get('appConfig');
  }

  setAppConf(appConfig) {
    return this.storage.set('appConfig', appConfig);
  }

  getUrlBaseAPI() {
    return this.storage.get('urlbaseapi');
  }

  setUrlBaseAPI(url) {
    return this.storage.set('urlbaseapi', url);
  }

  setUID(uid) {
    return this.storage.set('firebase_uid', uid);
  }

  getUID() {
    return this.storage.get('firebase_uid');
  }

  setTeam(team) {
    return this.storage.set('reference_db_team', team);
  }

  getTeam() {
    return this.storage.get('reference_db_team');
  }

  setDateBackgroundMode(date) {
    return this.storage.set('pass_background_mode', date);
  }

  getDateBackgroundMode() {
    return this.storage.get('pass_background_mode');
  }

  getMenuType() {
    return this.storage.get('menuType');
  }

  setMenuType(profile: any) {
    return this.storage.set('menuType', profile);
  }
  getTutorialShown() {
    return this.storage.get('tutorialShown');
  }
  setTutorialShown(tutorialShown) {
    return this.storage.set('tutorialShown', tutorialShown);
  }

  getWorkingDayShown() {
    return this.storage.get('workingDay');
  }
  setWorkingDayShown(workingDay) {
    return this.storage.set('workingDay', workingDay);
  }
}



// WEBPACK FOOTER //
// ./src/services/localStorage.service.ts